import { useEffect, useRef } from 'react';

interface Props {
  open: boolean;
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Byggd på <dialog> av samma skäl som LessonModal: fokus fångas, Escape
 * stänger och bakgrunden blir inert utan en egen fokusfälla.
 *
 * Avbryt-knappen har autofocus. Dialogen dyker upp när någon är på väg bort
 * från sidan, och då ska ett reflexmässigt Enter betyda "stanna kvar", inte
 * "kasta det jag skrivit".
 */
export function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}: Props) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  if (!open) return null;

  return (
    <dialog ref={ref} className="modal confirm" onCancel={onCancel} onClose={onCancel}>
      <div className="modal__inner confirm__inner">
        <h2 className="confirm__title">{title}</h2>
        <p className="confirm__body">{body}</p>
        <div className="row confirm__actions">
          <span className="grow" />
          <button type="button" className="button button--ghost" autoFocus onClick={onCancel}>
            {cancelLabel}
          </button>
          <button type="button" className="button button--danger" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </dialog>
  );
}
